<app-tabla
  [columns]="columns"
  [data]="tarifarios"
  [searchable]="true"
  [showCheckButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="true"
  [showActionsColumn]="false"
  (edit)="openEditTarifaModal($event)">
</app-tabla>
